import { render, staticRenderFns } from "./DefaultLoader.vue?vue&type=template&id=30b4021a&scoped=true&"
import script from "./DefaultLoader.vue?vue&type=script&lang=js&"
export * from "./DefaultLoader.vue?vue&type=script&lang=js&"
import style0 from "./DefaultLoader.vue?vue&type=style&index=0&id=30b4021a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b4021a",
  null
  
)

export default component.exports